import { render, staticRenderFns } from "./repaymentvsrealisasi.vue?vue&type=template&id=2a58996a&"
import script from "./repaymentvsrealisasi.vue?vue&type=script&lang=js&"
export * from "./repaymentvsrealisasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports